import Repository from '../axios'
import {defaultPagination} from "../constants/config";
const  resource = "/admin";

export default {
  getListOfHolidays() {
    return Repository.get(`${resource}/company_holiday_list`)
  },
  getListOfCompanyHolidays(pageNumber = 1, filterQuery, pagination = defaultPagination) {
    return Repository.get(`${resource}/company_holidays?paginate=${pagination}&page=${pageNumber}&${filterQuery}`)
  },
  createCompanyHoliday(payload) {
    return Repository.post(`${resource}/company_holidays`, payload)
  },
  deleteCompanyHoliday(id) {
    return Repository.delete(`${resource}/company_holidays/${id}`)
  },
  updateCompanyHoliday(id, payload) {
    return Repository.put(`${resource}/company_holidays/${id}`, payload)
  },
  detHolidayDetails(id) {
    return Repository.get(`${resource}/company_holidays/${id}`)
  }
};
